import { MASTER_KEY } from '../../funnel-map-flow/dialogs/import-funnel/utils';

export const getRecordTypeIdentifier = (recordTypeName: string | null, objectName: string) =>
  `${objectName}.${recordTypeName ?? MASTER_KEY}`;
